import React, { useState, useEffect } from "react";
import Serviceclasses from "./Aboutservices.module.css";
import { getdashboardServices } from "../../../Services/APIrequests";
import { BsFillBuildingsFill } from "react-icons/bs";
import {
  useNavigate,
  useLocation,
  useSearchParams,
  useParams,
} from "react-router-dom";
import { RiMoneyRupeeCircleFill } from "react-icons/ri";
import defaultIMG from "../../../Assets/defaultimg.png";
import parse from "html-react-parser";

// Component for rendering individual service cards
const ServiceCard = ({ service }) => {
  const navigate = useNavigate();
  const {
    title,
    shortDescription,
    thumbnailUrl,
    serviceId,
    servicePrice,
    isPriceShown,
  } = service;
  const defaultImage = "https://via.placeholder.com/150";

  const handleClick = (servicesid, servicetitle) => {
    navigate(`/services/${servicesid}/${servicetitle}`);
  };

  return (
    <div
      className={Serviceclasses.Servicecard}
      onClick={() => handleClick(serviceId, title)}
    >
      <div className={Serviceclasses.ServicecardImage}>
        {/* <div className={Serviceclasses.FlagBadge}>
          <img src="https://upload.wikimedia.org/wikipedia/en/4/41/Flag_of_India.svg" alt="India Flag" />
        </div> */}
        <img
          src={thumbnailUrl || defaultImage}
          className={Serviceclasses.MainCardImg}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null;
            currentTarget.src = defaultIMG;
          }}
          alt={title}
        />
      </div>
      <div className={Serviceclasses.Servicecard2}>
        <div className={Serviceclasses.ServicecardHeader}>
          <h2 className={Serviceclasses.ServicecardTitle}>{title}</h2>
          <div className={Serviceclasses.ServiceIcon}>
            <BsFillBuildingsFill />
          </div>
        </div>

        <p className={Serviceclasses.Servicecsmallarddescr}>
          {shortDescription ? parse(shortDescription) : "Description not available"}
        </p>

        <div className={Serviceclasses.Servicecard_readmore}>
          <div
            className={Serviceclasses.ServicecardLink}
            onClick={(e) => {
              e.stopPropagation();
              handleClick(serviceId, title);
            }}
          >
            Read More
          </div>
          {isPriceShown === 1 && (
            <div className={Serviceclasses.ServicecardLink}>
              <RiMoneyRupeeCircleFill
                className={Serviceclasses.ServicecardLink_icon}
              />
              {servicePrice}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// Component for rendering the service list based on filters
const Serviceclassess = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const [categoriesWithServices, setCategoriesWithServices] = useState([]);
  const { name } = useParams(); // Get category name from URL

  const fetchServices = async () => {
    setLoading(true);
    try {
      const response = await getdashboardServices();

      // console.log("Full API Response:", response.data);

      if (Array.isArray(response.data?.services)) {
        setCategoriesWithServices(response.data.services);
      } else {
        console.error("API response is not an array:", response.data?.services);
        setCategoriesWithServices([]);
      }
    } catch (err) {
      console.error("Error fetching services:", err);
    } finally {
      setLoading(false);
    }
  };

  // Effect to fetch services on component load and when 'name' (category name) changes
  useEffect(() => {
    fetchServices();
  }, [name, searchParams]);

  // Inside your Serviceclassess component's return
  return (
    <div>
      <div className={Serviceclasses.Servicecontainer}>
        {categoriesWithServices && categoriesWithServices.length > 0 ? (
          <div className={Serviceclasses.ServicecardGrid}>
            {categoriesWithServices
              .filter((service) => service.dashboard === "1")
              .map((service) => (
                <ServiceCard key={service.serviceId} service={service} />
              ))}
          </div>
        ) : (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              padding: "50px 0", // optional vertical spacing
            }}
          >
            <p>No services available for this category.</p>
          </div>
        )}
      </div>
    </div>
  );

};

export default Serviceclassess;
